import { HStack, Icon, Stack, Text } from "@chakra-ui/react";

import CrossSellsProduct from "../../molecules/CrossSellsProduct";
import React from "react";
import { TbStars } from "../../customIcons";

const CrossSellsSection = ({
  title,
  bundles,
  productPrice,
  productId,
  isCart,
  productName,
}: any) => {
  return (
    <Stack
      w="100%"
      bg="#F8FAFC"
      borderRadius="8px"
      p={3}
      maxW="736px"
      mb={isCart ? 0 : 9}
    >
      {isCart ? (
        <Text fontWeight="600" fontSize="16px">
          PAIR {productName.toUpperCase()} WITH
        </Text>
      ) : (
        <>
          {" "}
          <HStack>
            <Icon
              as={TbStars}
              color="#BB5D82"
              width="24px"
              height="24px"
              fill="#fff"
            />
            <Text fontWeight="600" fontSize="16px" color="#1A212D">
              {title.toUpperCase()}
            </Text>
          </HStack>
        </>
      )}

      <Stack
        bg="#EDF2F7"
        border="1px solid #E1E7EF"
        borderRadius="6px"
        spacing={0}
        gap={0}
      >
        <CrossSellsProduct
          productPrice={productPrice}
          bundles={bundles}
          productId={productId}
          isCart={isCart}
        />
      </Stack>
    </Stack>
  );
};

export default CrossSellsSection;
